import { useEffect, useRef } from 'react';
import { useExperience } from '@/store/experience';

// White-out layer driven by the cinematic timeline (clouds engulf the screen)
export function FogOverlay() {
  const ref = useRef();
  const frame = useExperience((s) => s.frame);
  useEffect(() => {
    let raf;
    const loop = () => {
      if (ref.current) {
        ref.current.style.opacity = frame.fog;
        ref.current.style.backdropFilter = frame.fog > 0.05 ? `blur(${frame.fog * 14}px)` : 'none';
      }
      raf = requestAnimationFrame(loop);
    };
    loop();
    return () => cancelAnimationFrame(raf);
  }, [frame]);
  return <div ref={ref} className="fixed inset-0 z-[35] pointer-events-none" style={{ opacity: 0, background: 'radial-gradient(ellipse at 50% 40%, rgba(255,255,255,1) 0%, rgba(240,246,255,0.98) 55%, rgba(210,228,250,0.95) 100%)' }} data-testid="fog-overlay" />;
}
